import React from "react";
import Avatar from "@vapor/react-extended/ExtendedAvatar";
import { VaporIcon } from "@vapor/react-icons/VaporIcon";
import { Checkbox } from "@vapor/react-material/Checkbox";
import {
  faWineBottle,
  faBriefcase,
  faChartMixed,
  faWarehouse,
} from "@fortawesome/pro-regular-svg-icons";
import {
  Chips,
  DataTableRow,
  DummyData,
  DummyData2,
  DummyData3,
  DummyData4,
} from "../features/UI/types";

export const notificationDummyData = [
  {
    id: 1,
    senderName: "",
    senderSurname: "",
    department: "Maintenance",
    status: 1,
    read: false,
    category: "message",
    title: "Sample Title 1",
    description:
      "This is the first sample description.orem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
    createdAt: "2023-09-25T10:00:00Z",
  },
  {
    id: 2,
    senderName: "Mario",
    senderSurname: "Altimasco",
    department: "WineCellar",
    status: 2,
    read: false,
    category: "message",
    title: "Sample Title 2",
    description:
      "Here's the second sample description.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    createdAt: "2023-09-25T06:30:00Z",
  },
  {
    id: 3,
    senderName: "Mario",
    senderSurname: "Altimasco",
    department: "WineCellar",
    status: 3,
    read: false,
    category: "order",
    title: "Another Example",
    description:
      "A different description for this example.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem",
    createdAt: "2023-09-25T08:15:00Z",
  },
  {
    id: 4,
    senderName: "",
    senderSurname: "",
    department: "HR",
    status: 1,
    read: true,
    category: "message",
    title: "New Entry 1",
    description: "Description for the new entry 1.",
    createdAt: "2023-09-25T09:45:00Z",
  },
  {
    id: 5,
    senderName: "",
    senderSurname: "",
    department: "Kitchen",
    status: 2,
    read: true,
    category: "message",
    title: "Custom Title",
    description: "Custom description goes here.",
    createdAt: "2023-09-25T15:20:00Z",
  },
  {
    id: 6,
    senderName: "",
    senderSurname: "",
    department: "Engineering",
    status: 3,
    read: true,
    category: "message",
    title: "Important Note",
    description: "An important note with details.",
    createdAt: "2023-09-25T12:00:00Z",
  },
  {
    id: 7,
    senderName: "",
    senderSurname: "",
    department: "Engineering",
    status: 1,
    read: true,
    category: "message",
    title: "Data Entry XYZ",
    description: "Description for data entry XYZ.",
    createdAt: "2023-09-25T16:30:00Z",
  },
];

export const UserData = {
  id: 1,
  username: "demo4",
  firstname: "Nome",
  lastname: "Cognome",
  email: "user.email@domain.com",
  language: "Italiano",
  region_format: "it-IT(Italia)",
};

export const chips: Chips[] = [
  {
    index: 1,
    icon: null,
    title: "Tutti",
  },
  {
    index: 2,
    title: "TSEnterprise",
    icon: (
      <Avatar>
        <VaporIcon icon={faBriefcase} />
      </Avatar>
    ),
  },
  {
    index: 3,
    icon: (
      <Avatar>
        <VaporIcon icon={faWineBottle} />
      </Avatar>
    ),
    title: "Cantina online",
  },
  {
    index: 4,
    icon: (
      <Avatar>
        <VaporIcon icon={faWarehouse} />
      </Avatar>
    ),
    title: "WMS",
  },
  {
    index: 5,
    icon: (
      <Avatar>
        <VaporIcon icon={faChartMixed} />
      </Avatar>
    ),
    title: "Calculations",
  },
  {
    index: 6,
    icon: (
      <Avatar>
        <VaporIcon icon={faChartMixed} />
      </Avatar>
    ),
    title: "Example",
  },
];

export const dummyData: DummyData[] = [
  {
    id: 1,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
  {
    id: 2,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
  {
    id: 3,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
  {
    id: 4,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
  {
    id: 5,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
  {
    id: 6,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
];

export const dummyData2: DummyData2[] = [
  {
    id: 7,
    logo: <VaporIcon icon={faWineBottle} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
  {
    id: 8,
    logo: <VaporIcon icon={faWineBottle} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
];

export const dummyData3: DummyData3[] = [
  {
    id: 9,
    logo: <VaporIcon icon={faChartMixed} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
  {
    id: 10,
    logo: <VaporIcon icon={faChartMixed} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
  {
    id: 11,
    logo: <VaporIcon icon={faChartMixed} />,
    title: "Foglia",
    content: "Prodoto/ voce menù/ scheda/ foglia",
  },
];

export const dummyData4: DummyData4[] = [
  {
    id: 10,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Entita foglia",
    content: "Magazine / Anagrafica clienti",
    time: "5min",
  },
  {
    id: 12,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Entita foglia",
    content: "Prodotto / voce menu / scheda / foglia",
    time: "10min",
  },
  {
    id: 13,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Entita foglia",
    content: "Prodotto / voce menu / scheda / foglia",
    time: "15min",
  },
  {
    id: 14,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Entita foglia",
    content: "Prodotto / voce menu / scheda / foglia",
    time: "09:00",
  },
  {
    id: 15,
    logo: <VaporIcon icon={faWarehouse} />,
    title: "Entita foglia",
    content: "Prodotto / voce menu / scheda / foglia",
    time: "08:00",
  },
  {
    id: 16,
    logo: <VaporIcon icon={faWineBottle} />,
    title: "Entita foglia",
    content: "Prodotto / voce menu / scheda / foglia",
    time: "7min",
  },
  {
    id: 17,
    logo: <VaporIcon icon={faWineBottle} />,
    title: "Entita foglia",
    content: "Prodotto / voce menu / scheda / foglia",
    time: "07:05",
  },
  {
    id: 18,
    logo: <VaporIcon icon={faChartMixed} />,
    title: "Entita foglia",
    content: "Prodotto / voce menu / scheda / foglia",
    time: "10min",
  },
  {
    id: 19,
    logo: <VaporIcon icon={faChartMixed} />,
    title: "Entita foglia",
    content: "Prodotto / voce menu / scheda / foglia",
    time: "09:10",
  },
  {
    id: 20,
    logo: <VaporIcon icon={faWineBottle} />,
    title: "Entita foglia",
    content: "Prodotto / voce menu / scheda / foglia",
    time: "7min",
  },
  {
    id: 21,
    logo: <VaporIcon icon={faWineBottle} />,
    title: "Entita foglia",
    content: "Prodotto / voce menu / scheda / foglia",
    time: "07:05",
  },
];

export const headers: string[] = [
  "Nome Cognome",
  "Azienda",
  "Note",
  "Telefono",
  "Cellulare",
  "Proprietario",
];
export const nomeCognomeData: string[] = Array(10).fill("Nome Cognome Test");
export const aziendaData: string[] = Array(10).fill("Nome Test");
export const noteData: string[] = Array(10).fill("Nome Test");
export const telefonoData: string[] = Array(10).fill("Nome Test");
export const cellulareData: string[] = Array(10).fill("Nome Test");
export const proprietarioData: string[] = Array(10).fill("Nome Test");

export const dummyDataTable: DataTableRow[] = Array(10)
  .fill(null)
  .map((_, index) => ({
    checkbox: (
      <Checkbox
        key={index}
        sx={{
          marginLeft: "3px",
        }}
      />
    ),
    NomeCognome: nomeCognomeData[index],
    Azienda: aziendaData[index],
    Note: noteData[index],
    Telefono: telefonoData[index],
    Cellulare: cellulareData[index],
    Proprietario: proprietarioData[index],
  }));
